import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { EventModel, EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { ShortNameModule, ShortTeamNamesService } from '@frontend/sports/betting-offer/feature/short-team-names';

@Component({
    selector: 'ms-tree-participant',
    template: `
        {{ participantName }}
        @if (participantCountry) {
            <span class="participant-country">{{ participantCountry }}</span>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class TreeParticipantComponent {
    @Input() event: EventModel;
    @Input() set participant(value: EventParticipant | undefined) {
        if (!value) {
            return;
        }

        this.setProperties(value);
    }

    @HostBinding('class') className = 'tree-participant';

    participantName = '';
    participantCountry = '';

    constructor(private shortTeamNamesService: ShortTeamNamesService) {}
    private setProperties(participant: EventParticipant): void {
        this.participantName = this.getParticipantName(participant);
        this.participantCountry = participant.country || '';
    }

    private getParticipantName(participant: EventParticipant): string {
        if (!participant) {
            return '';
        }

        if (this.shortTeamNamesService.shouldUseShortName(participant, this.event?.sport.id, this.event?.league.id, ShortNameModule.LeftHandNav)) {
            const name = participant.shortName!;

            return this.shortTeamNamesService.clearShortName(name);
        }

        return participant.name;
    }
}
